import React, { useState } from 'react';
import PropTypes from 'prop-types';
import differenceInYears from 'date-fns/differenceInYears';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { capitalize } from 'lodash';
import LoadingOverlay from 'components/LoadingOverlay';
import Member1 from 'assets/img/birds/groupmembers/member-1.png';
import Member2 from 'assets/img/birds/groupmembers/member-2.png';
import Member3 from 'assets/img/birds/groupmembers/member-3.png';
import Member4 from 'assets/img/birds/groupmembers/member-4.png';
import Member5 from 'assets/img/birds/groupmembers/member-5.png';
import Member6 from 'assets/img/birds/groupmembers/member-6.png';
import Toddler from 'assets/img/birds/groupmembers/toddler.png';
import { Row, MemberImage, Info, MediumText, Birthday } from './styled';

const memberPictures = [Member1, Member2, Member3, Member4, Member5, Member6];

const ApplicantDisplay = ({
  groupMember,
  loadingGroupMemberID,
  price,
  memberPictureIndex = 0,
  contractDuration,
  color
}) => {
  let icon = memberPictures[memberPictureIndex % memberPictures.length];

  const age = differenceInYears(new Date(), new Date(groupMember.dateOfBirth));
  if (age < 10) {
    icon = Toddler;
  }

  return (
    <Row $color={color}>
      <LoadingOverlay
        variant="light"
        isLoading={
          !!loadingGroupMemberID &&
          (loadingGroupMemberID === groupMember.groupMemberID ||
            loadingGroupMemberID === groupMember.userId)
        }
      />
      <MemberImage src={icon} alt="Group member" />
      <Info>
        <MediumText>
          {groupMember.firstName} {groupMember.lastName}
        </MediumText>
        <div>
          <Birthday>
            {format(
              parse(groupMember.dateOfBirth, 'yyyy-MM-dd', new Date()),
              'MMMM d, yyyy'
            )}{' '}
            •{' '}
          </Birthday>
          Age {age} • {capitalize(groupMember.gender)}
        </div>
        <MediumText>
          ${price} per {contractDuration} days
        </MediumText>
      </Info>
    </Row>
  );
};

ApplicantDisplay.propTypes = {
  groupMember: PropTypes.object,
  loadingGroupMemberID: PropTypes.number,
  price: PropTypes.number,
  memberPictureIndex: PropTypes.number,
  contractDuration: PropTypes.number,
  color: PropTypes.string
};

export default ApplicantDisplay;
